import React from "react";
import { RouteObject } from "react-router-dom";
import withSuspense from "../../components/wrappers/WithSuspense";
import { Preference } from "./pages";

const Container = React.lazy(() => import("."));
const Me = React.lazy(() => import("./pages/Me"));

export const profileRoutes: RouteObject[] = [
  {
    path: "",
    element: withSuspense(Container),
    children: [
      {
        path: "me",
        index: true,
        element: withSuspense(Me),
      },
      {
        path: "preference",
        element: withSuspense(Preference),
      },
    ],
  },
];
